import React from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { IFilterValue, IPagedListAction } from "../Declarations";
import { FilterDropdown } from "../FilterDropdown";

interface PagedListHeaderProps {
    filterValues: IFilterValue[];
    onFilterValueChanged: (filterValues: IFilterValue[]) => void;
    onFilterReset: () => void;
    total: number;
    first: number;
    last: number;
    headActions: IPagedListAction[];
    exportUrl?: string;
    csvExportUrl?: string;
    exportIcon?: IconDefinition;
    onDownloadExport: () => void;
    onExportCsv: () => void;
}

export const PagedListHeader: React.FC<PagedListHeaderProps> = ({
    filterValues,
    onFilterValueChanged,
    onFilterReset,
    total,
    first,
    last,
    headActions,
    exportUrl,
    csvExportUrl,
    exportIcon,
    onDownloadExport,
    onExportCsv
}) => {
    return (
        <div className="paged-list-header">
            {filterValues.length !== 0 && (
                <div className="filter-container">
                    <FilterDropdown 
                        filterValues={filterValues} 
                        onSave={onFilterValueChanged} 
                        onReset={onFilterReset} 
                    />
                </div>
            )}
            <div className="paged-list-results-count">
                <h6 className="mb-0">
                    {total === 0 && <span>No results to show</span>}
                    {total !== 0 && (
                        <span>
                            Showing results {first} - {last} of {total}
                        </span>
                    )}
                </h6>
            </div>
            <div className="paged-list-actions">
                {exportUrl && (
                    <Button variant="secondary" key={"ExportUrl"} onClick={onDownloadExport}>
                        {exportIcon && <FontAwesomeIcon fixedWidth={true} icon={exportIcon} className="me-2" />}
                        Export
                    </Button>
                )}
                {csvExportUrl && (
                    <Button variant="secondary" key={"csvExportUrl"} onClick={onExportCsv}>
                        {exportIcon && <FontAwesomeIcon fixedWidth={true} icon={exportIcon} className="me-2" />}
                        Export CSV
                    </Button>
                )}
                {headActions.map((action) => (
                    <Button 
                        className="btn-primary-custom d-flex align-items-center" 
                        key={action.text} 
                        onClick={() => action.onClick(null)}
                    >
                        {action.icon && <FontAwesomeIcon fixedWidth={true} icon={action.icon} className="me-2" />}
                        {action.text}
                    </Button>
                ))}
            </div>
        </div>
    );
};
